import VisibilityAwareWebSocket from "../../utils/visibilityAwareWebSocket";

export function observeNotifications({ store, work, socketBase, disabled }) {
    let socket = null, stopped = false, generation = 0, refreshTimer = null, startupTimer = null;
    let identity = "";
    const refresh = (invalidate = false) => {
        if (!stopped && identity && !document.hidden) store.dispatch("notifications/load", { work, invalidate });
    };
    const scheduleRefresh = () => {
        clearTimeout(refreshTimer);
        refreshTimer = setTimeout(() => refresh(true), 300);
    };
    const connect = () => {
        if (disabled || !socketBase || !identity) return;
        const url = new URL(`${location.protocol === "https:" ? "wss" : "ws"}://${socketBase.replace(/^wss?:\/\//, "")}`);
        url.pathname = "/ws/notifiche/";
        url.search = "";
        const current = generation;
        socket = new VisibilityAwareWebSocket(url.toString(), undefined, { minReconnectionDelay: 10000, maxReconnectionDelay: 60000 });
        socket.onopen = async () => {
            try {
                const response = await work.post("/notifiche/connessione/", {}, true);
                if (!stopped && current === generation) socket?.send(JSON.stringify({ ticket: response.data.ticket }));
            } catch { /* The next connection retries authentication. */ }
        };
        socket.onmessage = event => {
            if (current !== generation || stopped) return;
            try {
                const message = JSON.parse(event.data);
                if (message.type === "notifications.ready") {
                    clearTimeout(startupTimer);
                    // Read after joining the live channel, without a gap in updates.
                    refresh(true);
                } else if (message.type === "notifications.changed") scheduleRefresh();
            } catch { /* Ignore unrelated or malformed frames. */ }
        };
    };
    const syncIdentity = () => {
        const next = store.getters.isLoggedIn ? `${store.getters.userdata?.user_id}:${store.getters.userdata?.username}:${store.getters.token}` : "";
        if (next === identity) return;
        identity = next; generation++;
        clearTimeout(refreshTimer); clearTimeout(startupTimer); socket?.close(); socket = null;
        store.commit("notifications/reset");
        if (identity) {
            if (disabled || !socketBase) refresh();
            else {
                startupTimer = setTimeout(() => refresh(), 1500);
                connect();
            }
        }
    };
    const unsubscribe = store.subscribe(mutation => {
        if (["resetIdentity", "setIdentity", "token", "isLoggedIn", "userdata"].includes(mutation.type)) syncIdentity();
    });
    const onVisibility = () => { if (!document.hidden) refresh(); };
    document.addEventListener("visibilitychange", onVisibility);
    // Duty windows and personal reminders can expire without a source event.
    const fallback = setInterval(refresh, 180000);
    syncIdentity();
    return () => {
        stopped = true; generation++; unsubscribe(); clearInterval(fallback); clearTimeout(refreshTimer); clearTimeout(startupTimer);
        document.removeEventListener("visibilitychange", onVisibility); socket?.close(); store.commit("notifications/reset");
    };
}
